import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import Tooltip from "../../../../component/ui/tooltip";



const BillingCustomers = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [country, setCountry] = useState([]);
  const [pageItemsCount, setPageItemsCount] = useState(10);

  const [currentData, setCurrentData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [details, setDetails] = useState({});
  const [Total, setTotal] = useState();

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    Countries();
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `users/customers-list-settings${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTotal(res?.pagination?.total);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const Countries = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `location/get-countries`,
      });
      setCountry(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowEditModal(false);
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const editContact = (data) => {
    setCurrentData(data);
    setShowEditModal(true);
  };

  const filterModalData = [
    {
      name: "name",
      label: "Name",
      options: ["is", "contains"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
    {
      name: "email",
      label: "Email",
      options: ["is", "contains"],
      selectedOpt: "is",
      value: "",
      type: "email",
    },
    {
      name: "phone",
      label: "Phone",
      options: ["is,contains"],
      selectedOpt: "is",
      value: "",
      type: "number",
    },
    {
      name: "country",
      label: "Country",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: country,
      dropdownKey: "country_name",
      dropdownVal: "country_name",
    },
    {
      name: "state",
      label: "State",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
    {
      name: "city",
      label: "City",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
    {
      name: "assigned",
      label: "Assigned",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
  ];

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  <TableFilterReturn
                    filterReturn={filterReturn}
                    onChange={(allFilter) => {
                      setFilterReturn(allFilter);
                      getData({ filter: allFilter });
                    }}
                  />
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                          }`}
                        onClick={() => {
                          setShowModalFilterTable(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn}`}
                        onClick={() => {
                          setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <div className="flex justify-center items-center w-full h-full">
                    <DataNotFound title={"Clients"} />
                  </div>
                ) : (
                  <>
                    <TableCard ref={tableRef}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <TableHeaderWrap>
                                <span className="pl-[50px]">Name</span>
                              </TableHeaderWrap>
                            </TableCell>

                            {tableHeader?.map((eachHead, index) =>
                              eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                <TableCell header key={index}>
                                  <TableHeaderWrap>
                                    <span>{eachHead?.value}</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              ) : null
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div
                                    className={`${Style.tableActionArea} !gap-4`}
                                  >
                                    {eachList?.userimg ? (
                                      <>
                                        <div className="flex items-center gap-3">
                                          <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center">
                                            {eachList?.userimg ? (
                                              <img
                                                className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                                src={eachList?.userimg}
                                                alt={eachList?.name}
                                                onError={(e) => {
                                                  e.target.classList.add(
                                                    "hidden"
                                                  );
                                                  if (e.target.parentElement) {
                                                    e.target.parentElement.innerHTML = `
                              <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                ${eachList?.name?.split(" ")[0]?.[0] || ""}${eachList?.name?.split(
                                                      " "
                                                    )[1]?.[0] || ""
                                                      }
                              </div>`;
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.name?.split(" ")[0]
                                                  ? eachList?.name?.split(
                                                    " "
                                                  )[0][0]
                                                  : ""}
                                                {eachList?.name?.split(" ")[1]
                                                  ? eachList?.name?.split(
                                                    " "
                                                  )[1][0]
                                                  : ""}
                                              </div>
                                            )}
                                          </div>

                                          <div className="font-medium leading-5">
                                            {eachList?.name}
                                          </div>
                                        </div>


                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </div>
                                </TableCell>

                                {tableHeader?.map((eachHead, i) =>
                                  eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                    <>
                                      {eachHead.key === "team_info" ? (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList?.team_info ? (
                                            <div className="flex gap-1">
                                              <span>
                                                {eachList?.team_info?.team_name}
                                              </span>
                                              .
                                              <span>
                                                {eachList?.team_info?.team_type}
                                              </span>
                                            </div>
                                          ) : (
                                            "--"
                                          )}
                                        </TableCell>
                                      ) : eachHead.key == "email" ? (
                                        <TableCell key={`td-${i}`}>
                                          {eachList[eachHead?.key] ? (
                                            <a
                                              href={
                                                `mailto:${eachList[eachHead?.key]
                                                }` || ""
                                              }
                                            >
                                              {eachList[eachHead?.key] || "--"}
                                            </a>
                                          ) : (
                                            "--"
                                          )}
                                        </TableCell>
                                      ) : (
                                        <TableCell key={`${i}-${index}`}>
                                          {eachList[eachHead.key] ?? "--"}
                                        </TableCell>
                                      )}
                                    </>
                                  ) : null
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </>
                )}
              </div>

              {!isLoading ? (
                apiData?.length > 0 ? (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      {`showing 1 to ${apiData?.length} of ${tablePagination?.total || apiData?.length
                        }`}
                    </div>

                    {tablePagination ? (
                      <div className={Style.empDirectory_footer}>
                        {tablePagination?.next_page_url ? (
                          <button
                            className={Style.loadMoreBtn}
                            onClick={() => {
                              if (btnLoader) return;
                              // setPageCount(pageCount + 1);
                              setBtnLoader(true);
                              // filterData({ page: pageCount + 1, btnCall: true });
                              getData({
                                page: tablePagination?.next_page_url,
                              });
                            }}
                          >
                            {btnLoader ? (
                              <InnerLoader
                                className={Style.loader}
                                textStatus={false}
                              />
                            ) : (
                              "Load More"
                            )}
                          </button>
                        ) : null}
                      </div>
                    ) : null}

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                ) : null
              ) : (
                <div
                  className={Style.table_footer}
                  style={{ alignItems: "center" }}
                >
                  <div className={Style.table_footer_left}>
                    <Skeleton width={"50%"} height={15} />
                  </div>

                  <div className={Style.empDirectory_footer}>
                    <Skeleton width={"180px"} height={40} />
                  </div>

                  <div
                    className={`${Style.table_footer_left} ${Style.rightText}`}
                  ></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>


      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="customers-list-settings"
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="customers-list-settings"
        />
      )}


      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default BillingCustomers;
